import Api from '../services/Api';
import { ErrorDictionary } from '../pages/Components/Helpers/ErrorDictionary';
import { FornecedorRequest, Response } from './Types';

class FornecedorController {
  public static async Listar(request: FornecedorRequest): Promise<Response> {
    try {
      const response = await Api.post(`api/fornecedor/Listar`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async ListarUnico(FornecedorId: number): Promise<Response> {
    try {
      const response = await Api.get(
        `api/fornecedor/ListarUnico/${FornecedorId}`
      );

      const object = response?.data;

      const retorno: Response = {
        StatusCode: response.status,
        Data: object[0],
      };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Adicionar(request: FornecedorRequest): Promise<Response> {
    try {
      const response = await Api.post(`api/fornecedor/Adicionar`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Atualizar(request: FornecedorRequest): Promise<Response> {
    try {
      console.log('Controller Fornecedor Atualizar');
      console.log(request);

      const response = await Api.put(`api/fornecedor/Atualizar`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }

  public static async Excluir(request: FornecedorRequest): Promise<Response> {
    try {
      console.log('Controller Fornecedor Excluir');
      console.log(request);

      const response = await Api.put(`api/fornecedor/Excluir`, request);

      const object = response?.data;

      const retorno: Response = { StatusCode: response.status, Data: object };
      return retorno;
    } catch (error: any) {
      const retorno: Response = {
        StatusCode: error?.response?.status,
        Data: ErrorDictionary(error?.response?.status),
      };
      return retorno;
    }
  }
}

export default FornecedorController;
